import { render, staticRenderFns } from "./BindMobilePhone.vue?vue&type=template&id=f2bb748c&"
import script from "./BindMobilePhone.vue?vue&type=script&lang=js&"
export * from "./BindMobilePhone.vue?vue&type=script&lang=js&"
import style0 from "./BindMobilePhone.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!////node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports